import client from './client';

export const getTaobaoCapabilities = () => client.get('/system-config/taobao-capabilities');

export const updateTaobaoCapability = (capability, data) => (
  client.put(`/system-config/taobao-capabilities/${capability}`, data)
);

export const getWithdrawalPolicy = () => client.get('/system-config/withdrawal-policy');

export const updateWithdrawalPolicy = (data) => client.put('/system-config/withdrawal-policy', data);

export const getAiGuideVisibility = () => client.get('/system-config/ai-guide-visibility');

export const updateAiGuideVisibility = (data) => client.put('/system-config/ai-guide-visibility', data);
